import React, {  } from "react";
import { Row, Col, Alert } from 'reactstrap';

const ResetPassword = (props) => {
    const { onSubmit, isLoading, resetError, resetSuccess } = props;
    return (
        <form onSubmit={onSubmit}>
            <Row>
                <Col xs={{ "size": 10, "offset": 1 }} >
                    {
                        resetError && (
                            <Alert color="danger">
                                <div className="alert-message">
                                    {resetError}
                                </div>
                            </Alert>
                        )
                    }
                    {
                        resetSuccess && (
                            <Alert color="success">
                                <div className="alert-message">
                                    {resetSuccess}
                                </div>
                            </Alert>
                        )
                    }
                    <div className="form-group">
                        <input
                            type="text"
                            placeholder="Job Seeker Email Address"
                            name="email"
                            className="form-control-lg form-control"
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={{ "size": 6, "offset": 3 }} className="mt-4">
                	<div className="text-center">
                		<button className="btn-rounded btn-dark-blue btn btn-primary btn-lg btn-block">Submit</button>
                	</div>
                </Col>
            </Row>
        </form>
    )
}

export default ResetPassword;
